import React from 'react';
import './ToggleGroupIcon.scss';

interface Props {
  isOpen: boolean;
  size?: number;
  color?: string;
}

const ToggleGroupIcon: React.FC<Props> = ({ isOpen, size = 16, color = '#333' }) => {
  return (
    <svg
      className={`toggle-group-icon ${isOpen ? 'expanded' : ''}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
    >
      <polygon points="6,4 18,12 6,20" />
    </svg>
  );
};

export default ToggleGroupIcon;